import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/products/ProductItemComponent.tsx");
